<template>
  <v-row v-if="editedItem">
    <v-col
      cols="12"
      sm="12"
      md="12"
    >
      <css-editor
        v-if="id"
        :onSave="handleChangeStyle"
        :config="{ id: id, template: 'event' }"
      />
      <small v-else style="color: red;">[GUARDADO REQUERIDO]: para personalizar la CSS primero debe estar guardado.</small>
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="6"
    >
      <categories-places
        v-if="id"
        :id="id"
        :workspaceID="workspaceID"
        type="categories"
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="6"
    >
      <categories-places
        v-if="id"
        :id="id"
        :workspaceID="workspaceID"
        type="places"
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="6"
    >
      <v-checkbox
        v-model="editedItem.SelectableActivities"
        label="Actividades seleccionables"
        hide-details
        outlined
        @change="handleChange"
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="6"
    >
      <v-checkbox
        v-model="editedItem.Show"
        label="Vista de show"
        hide-details
        outlined
        @change="handleChange"
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="12"
    >
      <translate
        v-model="editedItem.ActivitiesTitle"
        label="Actividades título"
        :languages="languages"
        @input="handleChange"
        type="text"
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="12"
    >
      <translate
        v-model="editedItem.ShowsTitle"
        label="Show título"
        :languages="languages"
        @input="handleChange"
        type="text"
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="12"
    >
      <v-row style="background-color: #cccccc80;border-radius: 20px;">
        <v-col
          cols="12"
          sm="12"
          md="12"
        >
          Configuración Totem actividades tactil:
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="6"
        >
          <small>Logo:</small>
          <select-image
            :image="editedItem.TotemTactilLogo"
            :onChange="(v) => { handleChangeLogo(editedItem, v) }"
            :locale="locale"
            :folder="workspaceID"
            style="margin-left: 0px;margin-top:10px;"
          />
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="6"
        >
          <small>Screensaver:</small>
          <select-image
            :image="editedItem.TotemTactilScreensaver"
            :onChange="(v) => { handleChangeScreensaver(editedItem, v) }"
            :locale="locale"
            :folder="workspaceID"
            style="margin-left: 0;margin-right: 0;margin-top:10px;"
          />
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="12"
        >
          <v-text-field
            v-model="editedItem.TotemTactilQRURL"
            outlined
            label="QR URL"
            hide-details
            @input="handleChange"
          />
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="4"
        >
          <v-text-field
            v-model="editedItem.TotemTactilBGMainColor"
            outlined
            label="Color fondo"
            hide-details
            @input="handleChange"
          />
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="4"
        >
          <v-text-field
            v-model="editedItem.TotemTactilTextMainColor"
            outlined
            label="Color texto"
            hide-details
            @input="handleChange"
          />
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="4"
        >
          <v-checkbox
            v-model="editedItem.TotemTactilISDark"
            label="Modo oscuro"
            hide-details
            outlined
            @change="handleChange"
          />
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="6"
        >
          <v-autocomplete
            v-model="editedItem.TotemTactilMeteo"
            :items="meteos"
            outlined
            item-text="id"
            item-value="id"
            label="Meteo"
            hide-details
            @change="handleChange"
          />
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="6"
        >
        <v-select
          v-model="editedItem.TotemTactilAllIcon"
          :items="totemTactilIcons"
          label="Totem act tactil"
          outlined
          hide-details
          itemText="name"
          itemValue="id"
        />
      </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
const defaultItem = {
  ActivitiesTitle: { es: 'Programa de animación', en: 'Animation program'},
  ShowsTitle: { es: 'Programación semanal', en: 'Weekly Schedule'},
}
import api from '@/services/api'
import Translate from '@/components/Translate'
import SelectImage from '@/components/selectImage/Index'
import CssEditor from './cssEditor/Index'
import CategoriesPlaces from './categoriesPlaces/Index'
export default {
  components: {
    CssEditor,
    CategoriesPlaces,
    SelectImage,
    Translate,
  },
  props: {
    workspaceID: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      requried: true,
    },
    eventConfig: {
      type: Object,
      default: null,
    },
    onChange: {
      type: Function,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
    languages: {
      type: Array,
      default: null,
    },
    eventMeliaID: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    editedItem: null,
    totemTactilIcons: [],
    meteos: [],
  }),
  watch: {
    eventConfig () {
      this.prepareData()
    },
  },
  mounted () {
    this.handleGetConstants()
    this.prepareData()
  },
  methods: {
    handleGetConstants () {
      api.getAllWithoutLimit('dviewcontent', `v1/system/content-types/${this.id}/totem-tactil-icons`)
        .then(response => {
          this.totemTactilIcons = response
        })

      api.getAll ('meteo', 'v1/system/meteos/zones/', 0, 10000, '')
        .then(response => {
          this.meteos = response.data.map(item => {
            return {
              id: item.NombreMun,
            }
          })
        })
    },
    prepareData () {
      this.editedItem = this.eventConfig ? this.eventConfig : defaultItem
    },
    handleChangeStyle (v) {
      console.log('v', v)
    },
    handleChangeLogo (item, v) {
      if (!v) return
      item.TotemTactilLogo = v.base64
      item.newTotemTactilLogo = v
      this.handleChange()
    },
    handleChangeScreensaver (item, v) {
      if (!v) return
      item.TotemTactilScreensaver = v.base64
      item.newTotemTactilScreensaver = v
      this.handleChange()
    },
    handleChange () {
      this.onChange(this.editedItem)
    },
  },
}
</script>
